import React, { useState, useEffect } from "react";
import styles from "./TextAreaInput.module.css"; // Ensure styles are imported

type TextAreaHeightType = "short" | "medium" | "long"

interface TextAreaInputProps {
    placeholder?: string;
    message?: string;
    setMessage: (newMsg: string) => void;
    height?: TextAreaHeightType
    className?: string;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
    placeholder,
    message,
    setMessage,
    height = "short",
    className,
}) => {
    let heightClass;
    switch (height) {
        case "short":
            heightClass = styles.short;
            break;
        case "medium":
            heightClass = styles.medium;
            break;
        case "long":
            heightClass = styles.long;
            break;
    }

    return (
        <textarea
            className={`${styles.messageInput} ${className} ${heightClass}`}
            placeholder={placeholder}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
        />
    );
};

export default TextAreaInput;
